const Refresh = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 13 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.41281 3.38406C8.61905 2.64083 7.58895 2.23341 6.49614 2.23438C4.52943 2.2361 2.83156 3.5846 2.36278 5.45518C2.32865 5.59135 2.20733 5.6875 2.06695 5.6875H0.61199C0.421611 5.6875 0.276986 5.51467 0.312203 5.32756C0.86158 2.41018 3.42299 0.203125 6.5 0.203125C8.18716 0.203125 9.7193 0.866734 10.8498 1.94708L11.7566 1.04025C12.1405 0.656373 12.7969 0.928256 12.7969 1.47116V4.875C12.7969 5.21155 12.5241 5.48438 12.1875 5.48438H8.78366C8.24076 5.48438 7.96887 4.828 8.35275 4.4441L9.41281 3.38406ZM0.8125 7.51562H4.21634C4.75924 7.51562 5.03113 8.172 4.64725 8.5559L3.58719 9.61596C4.38095 10.3592 5.41112 10.7666 6.50396 10.7657C8.46965 10.7639 10.1682 9.41629 10.6372 7.54488C10.6713 7.40871 10.7927 7.31255 10.9331 7.31255H12.388C12.5784 7.31255 12.723 7.48538 12.6878 7.67249C12.1384 10.5898 9.57701 12.7969 6.5 12.7969C4.81284 12.7969 3.2807 12.1333 2.15021 11.0529L1.24338 11.9597C0.859498 12.3436 0.203125 12.0717 0.203125 11.5288V8.125C0.203125 7.78845 0.475947 7.51562 0.8125 7.51562Z"
			fill="#fff"
		/>
	</svg>
);

export default Refresh;



// WEBPACK FOOTER //
// ./src/js/app/icons/refresh.js